import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=03b0e31f&scoped=true"
import script from "./Right.vue?vue&type=script&setup=true&lang=ts"
export * from "./Right.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Right.vue?vue&type=style&index=0&id=03b0e31f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0e31f",
  null
  
)

export default component.exports